import styled from "styled-components";

export const Icon = styled.img`
    width: 50px;
    height: 50px;
    display: inline-block;
`
export const VolverArriba = styled.img`
    width: 76px;
    height: 76px;
    display: block;
    cursor: pointer;
`